module.exports = __webpack_public_path__ + "img/language.9d75bb7e.png";